module.exports = __webpack_public_path__ + "static/media/img_Inscription_kotobuki@2x.0a8ae33d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@2x/img_Inscription_kotobuki@2x.png
// module id = 974
// module chunks = 0